import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}>
      <circle cx={10} cy={10} r={10} fill="#00df76" />
      <path fill="#00ab5e" d="M10 0h-.014v20H10a10 10 0 000-20z" />
      <path
        fill="#fff5f5"
        d="M4.348 10.199l4.043 4.043a.452.452 0 00.639 0l6.636-6.638a.452.452 0 000-.639l-1.208-1.208a.452.452 0 00-.639 0l-4.828 4.828a.452.452 0 01-.639 0L6.188 8.421a.451.451 0 00-.63-.009l-1.2 1.139a.452.452 0 00-.009.647z"
      />
      <path
        fill="#dfebf1"
        d="M14.46 5.757a.452.452 0 00-.639 0L9.986 9.592v3.694l5.682-5.682a.452.452 0 000-.639z"
      />
    </svg>
  );
}

export default SvgComponent;
